import { render } from "./DividerComponent.vue?vue&type=template&id=18216233&scoped=true"
const script = {}

import "./DividerComponent.vue?vue&type=style&index=0&id=18216233&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18216233"]])

export default __exports__